import cn from 'classnames';
import { FC, PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';
import s from './tabs.module.css';
import { useSetActiveTabData } from './use-tabs';

export type TabType = {
  id: string;
  label: string;
  href?: string;
  disabled?: boolean;
} & PropsWithChildren;

interface Props {
  tabs: TabType[];
  activeTab: TabType;
  onChange?: (tab: TabType) => void;
  fullWidth?: boolean;
}

export const Tabs: FC<Props> = (props) => {
  const { activeTab, tabs, onChange, fullWidth } = props;
  const { activeTabData, ref } = useSetActiveTabData(activeTab);

  return (
    <ul className={s.component} ref={ref}>
      {tabs.map((item) => {
        const { id, label, href } = item;
        const isActive = activeTab.id === id;
        const className = cn(
          s.tab,
          isActive && s.active,
          item.disabled && s.disabled,
          fullWidth && s.fullWidth,
        );
        if (href) {
          return (
            <Link id={label + '-' + id} key={id} to={href} className={className}>
              {label}
            </Link>
          );
        }
        return (
          <li
            id={label + '-' + id}
            key={id}
            className={className}
            data-testid={id}
            onClick={() => {
              if (!item.disabled) onChange?.(item);
            }}
          >
            {label}
          </li>
        );
      })}
      <div style={activeTabData} className={s.activeTabIndicator} data-testid="active-indicator" />
    </ul>
  );
};
